/*
 *搜索结果页
 */
import { DatePicker, message, Space } from 'antd';
import Disclaimer from 'components/common/Disclaimer';
import HeaderMeta from 'components/headerMeta/HeaderMeta';
import moment from 'moment';
import React, { Component } from 'react';
import { buildPageBreadcrumb } from 'untils/jsonLdSchemas';
import '../../assets/style/itemStyle/emptyLeg.scss';
import Footer from '../../components/layout/Footer';
import SearchAirport from '../../components/public/SearchAirport';
import {
  getCityEmptyLegList,
  getEmptyLegList,
  getHotCity,
  getSearchEmptyLegList,
} from '../../services/index';
import {
  clearSessionStorage,
  getLocalStorage,
  getSessionStorage,
  roll,
  setSessionStorage,
} from '../../untils/auth';
import Description from './components/Description';
import EmptyLegList from './components/EmptyLegList';
import EmptyLegNav from './components/EmptyLegNav';
import Map from './components/Map';

import dayjs from 'dayjs';

const { RangePicker } = DatePicker;
const dateFormat = 'MMM DD,YYYY';

export default class CharterQuote extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fromValue: {}, // 出发地
      toValue: {}, // 目的地
      fromLocation: {
        // 出发地经纬度
        lat: 40,
        lng: -100,
      },
      toLocation: {
        // 目的地经纬度
        lat: 0,
        lng: 0,
      },
      startDate: '', // 去程日期
      endDate: '', // 返程日期
      fromName: 'default',
      toName: 'default',
      noticeShow: false, // 公告栏是否显示
      currentFocusInput: '',
      inputRules: {
        // 输入框校验
        fromCity: false, // 出发地
        toCity: false, // 目的地
        fromDate: false, // 去程日期
        toDate: false, // 返程日期
      },
      navList: [], //nav城市数据
      emptyLegList: [], //空腿列表
      routeListData: [], //传给地图的所有航线数据
      recommendList: [], //10mile推荐
      isSearch: false, //是否搜索过
      emptyLegSearchList: [],
    };
    this.height = 0;
  }

  // 自动聚焦 子传父
  getfocus = (value) => {
    if (value === 'to') {
      document.getElementById('picker').focus();
    }
  };
  // 获取热门城市推荐;
  getHotCityList = () => {
    getHotCity().then((res) => {
      if (res.code && Object.values(res.data).length) {
        let { navList } = this.state;
        navList = res.data.result;
        this.setState({
          navList,
        });
      }
    });
  };

  //获取all city的列表
  getEmptyLegData = async () => {
    await getEmptyLegList().then((res) => {
      if (res.code && Object.values(res.data).length) {
        let { emptyLegList } = this.state;
        emptyLegList = this.formatListData(res.data.emptyLegs);
        this.setState(
          {
            emptyLegList,
            routeListData: emptyLegList,
          },
          () => {
            const scrollY = Number(sessionStorage.getItem('/emptyLeg'));
            setTimeout(() => {
              window.scrollTo(0, scrollY);
            }, 400);
          }
        );
      }
    });
  };

  //切换城市导航
  switchNavHandle = (name) => {
    if (!name) return;
    if (name === 'All Cities') {
      this.getEmptyLegData();
    }
    let emptyLegList = [];

    //获取对应 city的列表
    getCityEmptyLegList(name).then((res) => {
      if (res.code && Object.values(res.data).length) {
        if (!res.data.emptyLegs) {
          emptyLegList = [];
        } else {
          emptyLegList = this.formatListData(res.data.emptyLegs);
        }
      }
      this.setState({
        emptyLegList,
        routeListData: emptyLegList,
      });
    });
  };

  //搜索空腿
  searchResults = () => {
    let { fromValue, toValue, startDate, endDate } = this.state;
    this.checkValue();
    if (
      Object.keys(fromValue).length > 0 &&
      Object.keys(toValue).length > 0 &&
      startDate &&
      endDate
    ) {
      let param = {
        startAirportId: fromValue.id,
        endAirportId: toValue.id,
        startDate: moment(startDate).format('YYYY-MM-DD'),
        endDate: moment(endDate).format('YYYY-MM-DD'),
        startIdType: fromValue.idType,
        endIdType: toValue.idType,
      };
      getSearchEmptyLegList(param).then((res) => {
        if (res.code) {
          if (res.data.emptyLegs) {
            let { emptyLegSearchList } = this.state;
            emptyLegSearchList = [];
            let list = this.formatListData(res.data.emptyLegs);
            let arr = [];
            let arr2 = [];
            for (let item of list) {
              if (new Date(item.endDate).getTime() <= new Date(endDate).getTime()) {
                arr.push(item);
              } else {
                arr2.push(item);
              }
            }
            emptyLegSearchList = [...arr, ...arr2];

            this.setState({
              emptyLegSearchList,
              routeListData: emptyLegSearchList,
            });
          } else {
            this.setState({
              emptyLegSearchList: [],
            });
          }
          if (!res.data.emptyLegs && res.data.EmptyLegPreferentialInfo) {
            let { recommendList } = this.state;
            recommendList = this.formatListData(res.data.EmptyLegPreferentialInfo);
            this.setState({
              recommendList,
            });
          }
        } else {
          if (!res.code) return message.error(res.msg);
        }
        this.setState({
          isSearch: true,
        });
      });
    }
  };

  //数据处理
  formatListData = (data) => {
    if (!Array.isArray(data)) return [];
    return data.map((item) => {
      const { Aircraft, startDate, endDate, price, ...rest } = item;
      return {
        ...rest,
        Aircraft: { ...Aircraft, Picture: JSON.parse(Aircraft?.Picture) },
        startDate: startDate.replace(/-/g, '/'),
        endDate: endDate.replace(/-/g, '/'),
        price: Math.ceil(price || 0),
      };
    });
  };

  //必填校验
  checkValue = () => {
    let { fromValue, toValue, startDate, endDate, inputRules } = this.state;

    let notValueLength = 0;

    if (!Object.keys(fromValue).length) {
      notValueLength++;
    } else {
      inputRules.fromCity = false;
    }

    if (!Object.keys(toValue).length) {
      notValueLength++;
    } else {
      inputRules.toCity = false;
    }

    if (!startDate) {
      notValueLength++;
    } else {
      inputRules.fromDate = false;
    }

    if (!endDate) {
      notValueLength++;
    } else {
      inputRules.toDate = false;
    }

    this.setState({
      inputRules,
    });

    // 都未填只提示弹窗信息
    if (notValueLength === 4) {
      return message.warning('Please enter your information!');
    }

    // 未填写>1, 提示弹窗信息并且置亮input
    if (notValueLength > 1 && notValueLength <= 4) {
      if (!Object.keys(fromValue).length) inputRules.fromCity = true;
      if (!Object.keys(toValue).length) inputRules.toCity = true;
      if (!startDate) inputRules.fromDate = true;
      if (!endDate) inputRules.toDate = true;

      this.setState({
        inputRules,
      });
      return message.warning('Please enter your information!');
    }

    // 仅一项未填提示弹窗信息并且置亮input
    let msg = '';
    if (notValueLength === 1) {
      if (!Object.keys(fromValue).length) {
        inputRules.fromCity = true;
        msg = 'Please enter the place of departure';
      }
      if (!Object.keys(toValue).length) {
        inputRules.toCity = true;
        msg = 'Please enter the destination place';
      }

      if (!startDate) {
        inputRules.fromDate = true;
        msg = 'Please enter the date';
      }
      if (!endDate) {
        inputRules.toDate = true;
        msg = 'Please enter the date';
      }

      this.setState({
        inputRules,
      });

      return message.warning(msg);
    }

    // 都已填，出发地/目的地相同
    if (notValueLength === 0) {
      if (fromValue.id && toValue.id && fromValue.id === toValue.id) {
        return message.warning('The departure city and destination city cannot be the same!');
      }
    }
  };

  // 互换出发目的地
  reverse = () => {
    let { fromValue, toValue } = this.state;

    let flyLocationForm = getSessionStorage('flyLocationForm') || {};
    let flyLocationTo = getSessionStorage('flyLocationTo') || {};
    if (flyLocationForm.length) flyLocationForm = JSON.parse(flyLocationForm);
    if (flyLocationTo.length) flyLocationTo = JSON.parse(flyLocationTo);

    setSessionStorage('flyLocationForm', JSON.stringify(flyLocationTo));
    setSessionStorage('flyLocationTo', JSON.stringify(flyLocationForm));

    setSessionStorage('from', JSON.stringify(toValue));
    setSessionStorage('to', JSON.stringify(fromValue));
    this.setState({
      fromValue: toValue,
      toValue: fromValue,
    });
    // 获取缓存数据
    this.getCacheData();
    if (this.ChildPage1) {
      this.ChildPage1.getCacheData(); //调用出发子组件的dream方法
      this.ChildPage2.getCacheData(); //调用到达子组件的dream方法
    }
  };

  // 获取机场地址（子传父）
  getAddress = (type, data) => {
    if (type === 'from') {
      this.setState({
        fromValue: data,
      });
    } else {
      this.setState({
        toValue: data,
      });
    }
    // 获取缓存数据
    this.getCacheData();
  };

  // 地图选中地址
  addressValue = (name, value) => {
    let { fromValue, toValue, fromName, toName } = this.state;
    if (name === 'from') {
      fromValue = value;
      fromName = JSON.parse(value.additional).airportIcao;
    } else {
      toValue = value;
      toName = JSON.parse(value.additional).airportIcao;
    }
    this.setState({
      fromValue,
      toValue,
      fromName,
      toName,
    });
    if (this.ChildPage1) {
      this.ChildPage1.getCacheData(); //调用出发子组件的dream方法
      this.ChildPage2.getCacheData(); //调用到达子组件的dream方法
    }
  };

  // 获取默认出发地，目的地
  getCacheData = () => {
    //去程机场
    //返程机场
    const from = JSON.parse(getSessionStorage('from') || '{}');
    const to = JSON.parse(getSessionStorage('to') || '{}');
    const startDate = getSessionStorage('emptyLegsStartDate') || '';
    const endDate = getSessionStorage('emptyLegsEndDate') || '';

    // Helper function to parse location
    const parseLocation = (location) => {
      if (!location) return null;

      const locationObj = typeof location === 'string' ? JSON.parse(location) : location;

      return {
        lat: locationObj.lati,
        lng: locationObj.long,
      };
    };

    // Parse locations
    const fromLocation = parseLocation(from.location) || this.state.fromLocation;
    const toLocation = parseLocation(to.location) || this.state.toLocation;

    // Parse airport names
    const fromName = from.additional ? JSON.parse(from.additional).airportIcao : '';
    const toName = to.additional ? JSON.parse(to.additional).airportIcao : '';

    this.setState({
      fromValue: from,
      toValue: to,
      fromName,
      toName,
      fromLocation,
      toLocation,
      startDate,
      endDate,
    });
  };

  goCharterQuote = () => {
    this.props.history.push({
      pathname: '/charterQuote',
    });
  };

  //清除数据
  clearSearchHandle = async () => {
    clearSessionStorage('from');
    clearSessionStorage('to');
    clearSessionStorage('flyLocationTo');
    clearSessionStorage('flyLocationForm');
    clearSessionStorage('userFormData');
    clearSessionStorage('emptyLegsStartDate');
    clearSessionStorage('emptyLegsEndDate');
    let { emptyLegList } = this.state;
    this.ChildPage1.getCacheData(); //调用出发子组件的dream方法
    this.ChildPage2.getCacheData(); //调用到达子组件的dream方法
    this.setState({
      startDate: '',
      endDate: '',
      isSearch: false,
      routeListData: emptyLegList,
    });

    if (this.state.navList) this.getHotCityList();
    if (this.state.emptyLegList) this.getEmptyLegData();
  };

  // 获取日期
  changeDate = (e) => {
    let { startDate, endDate } = this.state;
    startDate = e[0];
    endDate = e[1];
    this.setState({
      startDate,
      endDate,
    });
    setSessionStorage('emptyLegsStartDate', startDate);
    setSessionStorage('emptyLegsEndDate', endDate);
    let userFormData = {
      dateStart: moment(new Date(startDate)).format('MM/DD/YYYY'),
      passenger: 1,
      type: 0,
      emptyleg: true,
    };
    setSessionStorage('userFormData', JSON.stringify(userFormData));
  };

  // 显示开始日期
  disabledDateStart = (current) => {
    // Can not select days before today and today
    return current && current < moment().startOf('day');
  };

  //更新出发地&目的地聚焦
  updateInputFocus = (type) => {
    this.setState({
      currentFocusInput: type,
    });
  };

  //更新出发地&目的地校验
  updateInputRules = (type) => {
    let { inputRules } = this.state;
    //更新出发地、目的地校验
    if (type === 'from') {
      inputRules.fromCity = false;
    } else {
      inputRules.toCity = false;
    }
    this.setState({
      inputRules,
    });
  };

  //有无通告栏时样式处理
  mapControlStyle = () => {
    if (
      !getLocalStorage('token') &&
      !getSessionStorage('notice') &&
      getSessionStorage('isCoupons')
    ) {
      let domStyle = '.gm-fullscreen-control{top: 126rem !important;}';
      this.handleMapFullScreenStyle(domStyle);
    } else {
      let domStyle = '.gm-fullscreen-control{top: 86rem !important;}';
      this.handleMapFullScreenStyle(domStyle);
    }
  };
  // 地图全屏控件样式
  handleMapFullScreenStyle = (controlStyle) => {
    let domStyle = controlStyle;
    let dom = document.getElementsByClassName('empty_leg_container')[0];
    let style = document.createElement('style');
    style.type = 'text/css';
    if (style.styleSheet) {
      style.styleSheet.cssText = domStyle;
    } else {
      style.appendChild(document.createTextNode(domStyle));
    }
    dom.appendChild(style);
  };

  async componentDidMount() {
    this.props.history.listen((router) => {
      let path = router.pathname.split('/')[1];
      if (!['emptyLeg', 'emptyLegDetails'].includes(path)) {
        sessionStorage.setItem('/emptyLeg', '');
      }
      /*页面回到顶部 */
      if (document.body.scrollTop || document.documentElement.scrollTop > 0) {
        window.scrollTo(0, 0);
      }
    });
    roll(0);
    this.mapControlStyle();
    // 获取默认出发地，目的地
    this.getCacheData();

    let { fromValue, toValue, startDate, endDate } = this.state;
    //去程机场
    fromValue = !JSON.parse(getSessionStorage('from')) ? {} : JSON.parse(getSessionStorage('from'));
    //返程机场
    toValue = !JSON.parse(getSessionStorage('to')) ? {} : JSON.parse(getSessionStorage('to'));
    startDate = !getSessionStorage('emptyLegsStartDate')
      ? ''
      : getSessionStorage('emptyLegsStartDate');
    endDate = !getSessionStorage('emptyLegsEndDate') ? '' : getSessionStorage('emptyLegsEndDate');

    if (fromValue && toValue && startDate && endDate) {
      this.setState(
        {
          fromValue,
          toValue,
          startDate,
          endDate,
          isSearch: true,
        },
        () => {
          //搜索数据
          this.searchResults();
        }
      );
    } else {
      //获取热门城市导航
      this.getHotCityList();

      //获取空腿all数据
      await this.getEmptyLegData();
    }
    window.addEventListener('scroll', this.menuHandleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.menuHandleScroll);
  }
  menuHandleScroll = () => {
    if (window.scrollY > 350) {
      sessionStorage.setItem('/emptyLeg', String(window.scrollY));
    }
  };
  render() {
    const currentDate = dayjs(new Date()).format('MMM DD, YYYY');

    let {
      startDate,
      endDate,
      toValue,
      fromValue,
      currentFocusInput,
      inputRules,
      navList,
      emptyLegList,
      routeListData,
      emptyLegSearchList,
      recommendList,
      isSearch,
    } = this.state;

    return (
      <>
        <HeaderMeta type="emptyLegs" jsonLd={[buildPageBreadcrumb('Empty Legs', '/emptyLeg')]} />
        <div className="container empty_leg_container" id="emptyLeg">
          {/* 地图 */}
          <div className="empty_map">
            <Map
              onRef={(c) => (this.ChildPage = c)}
              addressValue={this.addressValue}
              emptyLegList={routeListData}
            />
          </div>

          <div className={`empty_leg_content ${isSearch ? 'empty_leg_search_result' : ''}`}>
            <div className="emptylegs-results-options">
              <div className="results-address">
                <div className="address-item">
                  <SearchAirport
                    type="from"
                    page="emptylegs"
                    dataValue={fromValue}
                    resultSstyle="results-style"
                    getAddress={this.getAddress}
                    onRef={(c) => (this.ChildPage1 = c)}
                    currentFocusInput={currentFocusInput}
                    inputRules={inputRules}
                    updateInputFocus={this.updateInputFocus}
                    updateInputRules={this.updateInputRules}
                    getfocus={this.getfocus}
                  />
                </div>
                <div className="address-item swap-item">
                  <button
                    className="swap"
                    onClick={() => {
                      this.reverse();
                    }}
                  >
                    <i></i>
                  </button>
                </div>
                <div className="address-item">
                  <SearchAirport
                    type="to"
                    page="emptylegs"
                    dataValue={toValue}
                    resultSstyle="results-style"
                    getAddress={this.getAddress}
                    onRef={(c) => (this.ChildPage2 = c)}
                    currentFocusInput={currentFocusInput}
                    inputRules={inputRules}
                    updateInputFocus={this.updateInputFocus}
                    updateInputRules={this.updateInputRules}
                    getfocus={this.getfocus}
                  />
                </div>
                <div className="address-item">
                  <div className="results-deta">
                    <div className="icon-text">
                      <img
                        src={require('../../assets/imgs/svg/date.svg').default}
                        alt="date icon"
                      />
                      <span className={`${inputRules.fromDate ? 'error' : ''}`}>
                        Departure Date
                      </span>
                    </div>
                    <div className="date-time-item">
                      <Space direction="vertical" size={12}>
                        <RangePicker
                          id="picker"
                          format={'MMM DD,YYYY'}
                          suffixIcon={''}
                          allowClear={false}
                          bordered={false}
                          disabledDate={this.disabledDateStart}
                          placeholder={[currentDate, currentDate]}
                          value={
                            startDate && endDate
                              ? [moment(startDate, dateFormat), moment(endDate, dateFormat)]
                              : ''
                          }
                          onChange={(a, e) => this.changeDate(e)}
                          getPopupContainer={(triggerNode) => triggerNode.parentNode}
                        />
                      </Space>
                    </div>
                  </div>
                </div>
              </div>
              <button className="search_options" onClick={() => this.searchResults()}>
                <img
                  src={require('../../assets/imgs/svg/emptyLeg/seach_btn.svg').default}
                  alt="search button"
                />
              </button>
            </div>

            {isSearch ? (
              <>
                <div className="search_top">
                  <span className="total">
                    {emptyLegSearchList ? emptyLegSearchList.length : 0} empty legs{' '}
                  </span>
                  <button className="clear_btn" onClick={this.clearSearchHandle}>
                    Clear search
                  </button>
                </div>

                <div style={{ textAlign: 'center', marginTop: '16px' }}>
                  <p>
                    *All advertised rates are net prices and are subject to taxes, regulatory fees,
                    or other charges, which may vary based on routing and availability*
                  </p>
                  <Disclaimer />
                </div>
                {emptyLegSearchList.length > 0 ? (
                  // 有搜索结果的
                  <EmptyLegList emptyLegList={emptyLegSearchList} history={this.props.history} />
                ) : (
                  <>
                    <div className="no_result_list">
                      <div className="noData">
                        <img
                          src={require('../../assets/imgs/webp/blog-noData.webp').default}
                          alt="nodata"
                        />
                        <p>Not found, Please search again</p>
                      </div>
                      <p>
                        If no more matching Empty Legs can be found, please choose Private Charters
                        and customize your time and location.
                      </p>
                      <button
                        className="link_btn"
                        onClick={(e) => {
                          this.goCharterQuote(e);
                        }}
                      >
                        Inquire
                      </button>
                    </div>
                    {recommendList && recommendList.length > 0 && (
                      <div className="near_airport">
                        <div className="near_airport_total">
                          <span>{recommendList ? recommendList.length : 0} Recommended flight</span>
                          <span>Airport near 10mile</span>
                        </div>
                        <EmptyLegList emptyLegList={recommendList} history={this.props.history} />
                      </div>
                    )}
                  </>
                )}
              </>
            ) : (
              <>
                <EmptyLegNav nav={navList} onSelect={this.switchNavHandle} />
                <div style={{ textAlign: 'center', margin: '16px 0' }}>
                  <p>
                    *All advertised rates are net prices and are subject to taxes, regulatory fees,
                    or other charges, which may vary based on routing and availability*
                  </p>
                  <Disclaimer />
                </div>

                <EmptyLegList
                  emptyLegList={emptyLegList}
                  history={this.props.history}
                  key={Math.random()}
                />
              </>
            )}
          </div>
          <Description />

          <Footer />
        </div>
      </>
    );
  }
}
